import React from 'react';
import {Grid,Chip} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment'
import {isEmpty} from 'lodash'
import {useSelector, useDispatch} from 'react-redux'
import {getArtikelTags,onGetMinaChild,getChildKontoUsers} from 'actions'
import { injectIntl } from 'react-intl';

const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      padding: theme.spacing(2),
    }
  }));
function ChipsList(props) {
    const dispatch = useDispatch()
    const Afid = useSelector(state => state.auth.authUser.user_Afid)
    const userid = useSelector(state => state.auth.authUser.user_id)
    const ChildList = useSelector(state => state.accountsData.ChildList)
    const Kontonamn = useSelector(state => state.accountsData.currentAccount.name)
    const ChildKontoUsers = useSelector(state => state.accountsData.ChildKontoUsers)
    const DashboardFilterOption = useSelector(state => state.DashBoard.DashboardOrderFilterOption)
    const DateFrom = props.intl.formatMessage({ id: 'Chips.Date.from' });
    const DateTo = props.intl.formatMessage({ id: 'Chips.Date.to' });
    const KontonLabel = props.intl.formatMessage({ id: 'A.Account' });
    const AnsvarigLabel = props.intl.formatMessage({ id: 'appKontoModule.Owner' });
    const AllLabel = props.intl.formatMessage({ id: 'All' });
    const AllOfficeLabel = props.intl.formatMessage({ id: 'All.In.Office' });
    const UserLabel = props.intl.formatMessage({ id: 'User' });
    const ArtikelTaggs = props.intl.formatMessage({ id: 'Chips.Products.Tags' });
    //console.log(props)
    const classes = useStyles();
    const ArtikelTagsList = useSelector(state => state.ArtikelReg.ArtikelTagsList)
    React.useEffect(()=>{
        if(!isEmpty(props.Chips.filter(item=>{return item.Meta === "Artikel_Etiketter"}))){
            dispatch(getArtikelTags(Afid,userid))
        }  
    },[])
    React.useEffect(()=>{
        if(isEmpty(ChildList)){
            dispatch(onGetMinaChild(Afid))
        }
        if(!isEmpty(props.Chips.filter(item=>{return item.Meta === "Konton"}))){
            const Konto = props.Chips.filter(item=>{return item.Meta === "Konton"})[0].Value
            dispatch(getChildKontoUsers(Afid,userid,Konto))
        }
    },[DashboardFilterOption])

    const GetMeta =(Meta)=>{
        switch(Meta){
            case "Konton":return KontonLabel
            case "KontonUser":return AnsvarigLabel
            case "ansvarig":return AnsvarigLabel
            case "DatumFrom":return DateFrom
            case "DatumTo":return DateTo
            case "Artikel_Etiketter":return ArtikelTaggs
        }
    }
    const GetValue =(n)=>{
        switch(n.Meta){
            case "ansvarig":
                if(parseInt(n.Value) === -1){
                    return AllLabel
                }
                else if(parseInt(n.Value) === -2){
                    return AllOfficeLabel
                }
                else{
                    const UserObject = props.Userlista.filter(item=>{return item.id === parseInt(n.Value)})
                    return `${UserObject[0].FirstName} ${isEmpty(UserObject[0].LastName)?"":UserObject[0].LastName}`    
                }
            case "DatumFrom":return moment(n.Value).format("YYYY-MM-DD")
            case "DatumTo":return moment(n.Value).format("YYYY-MM-DD")
            case "Artikel_Etiketter":return getArtikelEtiketter(n.Value)
            case "Konton":return getKontonNamn(n.Value)
            case "KontonUser":return getKontonUser(n.Value)
            default: return `${n.Value}`
        }
    }
    const getArtikelEtiketter=(Value)=>{
        if(Value.toString()  === '-1'){
            return AllLabel
        }
        else{
            let Keyword =isEmpty(ArtikelTagsList)?"":ArtikelTagsList.filter(item => {return parseInt(item.id) === parseInt(Value)})[0].Keyword
            return Keyword
        }
    }
    const getKontonNamn=(Value)=>{
        if(Value.toString()  === '-1'){
            return AllLabel
        }
        else if(parseInt(Afid) === parseInt(Value)){
            return Kontonamn
        }
        else{
            console.log(ChildList,"ASD")
            let Konto =isEmpty(ChildList)?"":ChildList.filter(item => {return parseInt(item.ChildAfid) === parseInt(Value)})[0].name
            return Konto
        }
    }
    const getKontonUser=(Value)=>{
        
        if(Value.toString()  === '-1'){
            return AllLabel
        }
        else{
            let Konto = isEmpty(ChildKontoUsers)?"":ChildKontoUsers.filter(item => {return parseInt(item.id) === parseInt(Value)})
            let name = isEmpty(Konto)?UserLabel:`${Konto[0].FirstName} ${isEmpty(Konto[0].LastName)?"":Konto[0].LastName}`
            return name
        }
    }
    const handleDelete=(n)=>{
        props.handleDeleteOptions(n)
    }
    return (
        <Grid container className={classes.root} spacing={2}>
           {    
                isEmpty(props.Chips)?"":
               props.Chips.map(n=>{
                   return (
                    <Grid item spacing={1} >
                        <Chip 
                        color="primary" 
                        size="small" 
                        style={{background:"#0c969c", color:"#fff",borderRadius:"0"}}
                        label={`${GetMeta(n.Meta)}: ${GetValue(n)}`}
                        onDelete={()=>handleDelete(n)} 
                        />
                    </Grid>
                   )
               })
           } 
        </Grid>
    );
}

export default injectIntl(ChipsList);